import { render } from "./PrSupportPage.vue?vue&type=template&id=4471478c"
import script from "./PrSupportPage.vue?vue&type=script&lang=js"
export * from "./PrSupportPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__